import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_money = _resolveComponent("l-money")!

  return (_openBlock(), _createElementBlock("td", _hoisted_1, [
    _createVNode(_component_l_money, { model: $props.model }, null, 8, ["model"])
  ]))
}